"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layouts = exports.colors = exports.breakpoints = void 0;
var colors = {
  white: '#fff',
  whiteLowContrast: 'rgba(255, 255, 255, 0.7)',
  whiteHighContrast: 'rgba(255, 255, 255, 0.95)',
  black: '#000000',
  blackHighContrast: 'rgba(0, 0, 0, 0.9)',
  blackLowContrast: 'rgba(0, 0, 0, 0.6)',
  blackOverlay: 'rgba(0, 0, 0, 0.2)',
  main: '#000',
  pinkAmour: '#f6e6f2',
  gray: '#858585',
  darkGray: '#575757',
  silver: '#ccc',
  border: '#ccc',
  silverChalice: '#aeaeae',
  grayAlto: '#d1d1d1',
  grayAltoDark: '#cecece',
  grayAlabaster: '#f7f7f7',
  grayAthens: '#e6e8ed',
  greenPersian: '#36b587',
  secondary: '#36b587',
  greenNasty: '#6eb243',
  berry: '#a51780',
  mintCream: '#E7FAF3',
  palePurple: '#FFE4FA',
  paypoGreen300: '#7EE4BD',
  paypoGreen400: '#54DBA7',
  paypoGreen500: '#2CD091',
  paypoGreen600: '#22A271',
  paypoGreen700: '#187350',
  paypoGreen900: '#051710',
  paypoGrey50: '#F4F4F4',
  paypoGrey200: '#CCC',
  paypoGrey500: '#8C8C8C',
  paypoGrey900: '#1A1A1A',
  paypoDarkGreen: '#187350',
  paypoLigthtGrey: '#E6E6E6',
  paypoInactive: '#B2B2B2',
  paypoFuchsia500: '#A70584',
  paypoFuchsia900: '#430236',
  yellow500: '#FAC42F',
  grayDark: '#333333',
  paypoError: '#EB1730',
  paypoShadowGrey01: '0px 2px 16px rgba(0, 0, 0, 0.02), 0px 2px 7px rgba(0, 0, 0, 0.0402), 0px 1px 3.5px rgba(0, 0, 0, 0.04), 0px 1px 2.00345px rgba(0, 0, 0, 0.0398), 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 0px 0.5px rgba(0, 0, 0, 0.06)',
  transparent: 'rgba(0, 0, 0, 0)'
};
exports.colors = colors;
var breakpoints = {
  smallMobile: '360px',
  bigMobile: '500px',
  medium: '768px',
  big: '1024px',
  large: '1140px'
};
exports.breakpoints = breakpoints;
var layouts = {
  basic: '114rem'
};
exports.layouts = layouts;